import React from 'react';
import './Benefits.css';

interface Benefit {
  icon: string;
  title: string;
  description: string;
}

interface BenefitsProps {
  onNavigate?: (page: string) => void;
}

const Benefits: React.FC<BenefitsProps> = ({ onNavigate }) => {
  const benefits: Benefit[] = [
    {
      icon: '💪',
      title: 'Physical Fitness',
      description: 'Through dedicated practice, develop strength, flexibility, and coordination while honoring the physical demands of ITF Traditional Taekwon-Do.'
    },
    {
      icon: '🧘',
      title: 'Mental Discipline',
      description: 'Develop focus, concentration, and mental resilience that extends beyond the dojang.'
    },
    {
      icon: '🛡️',
      title: 'Self-Defense',
      description: 'Learn practical self-defense techniques grounded in traditional principles, developing both skill and awareness.'
    },
    {
      icon: '📜',
      title: 'Personal Growth',
      description: 'Embrace the journey of continuous improvement, where each belt represents dedication, perseverance, and personal achievement.'
    },
    {
      icon: '🤝',
      title: 'Respectful Community',
      description: 'Train alongside fellow practitioners in an environment built on mutual respect and shared commitment to growth.'
    },
    {
      icon: '🌟',
      title: 'Character Development',
      description: 'Develop inner strength, humility, self-confidence and integrity through the traditional values and teachings of ITF Taekwon-Do.'
    }
  ];

  return (
    <section className="benefits-section">
      <div className="container">
        <h2 className="section-title">Benefits of Taekwon-Do</h2>
        <p className="section-subtitle">
          A journey of discipline, respect, and personal development
        </p>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>
        <div className="more-info-container">
          <button className="more-info-button" onClick={() => {
            if (onNavigate) {
              onNavigate('about-our-club');
            }
          }}>
            Learn More About Our Club
          </button>
        </div>
      </div>
    </section>
  );
};

export default Benefits;

